<template>
	<div class="indexContainer">
		<Header></Header>
		<div class="bannerWrapper" style="position: relative;">
			<img src="../../assets/img/tecSystem/banner1.jpg" alt="" class="bannerImg" />
			<div class="banner-float container">
				<ul class="wow slideInUp">
					<li class="item-box" id="" v-for="item in classifyList">
						<a href="javascript:;">
							<b class="item-icon"></b>
							<div class="info-box">
								<h3 class="title">{{item.name}}</h3>
								<p class="font">
									{{item.text}}
								</p>
							</div>
							<div class="item-detail">
								<p class="title">{{item.name}}</p>
								<p class="text">{{item.detail}}</p>
							</div>
						</a>
					</li>
				</ul>
			</div>
		</div>
		<div class="indexContentContainer wow slideInUp">
			<div class="part-box container">
				<div class="part-titile">
					<h3 class="title">位置监控方案</h3>
				</div>
				<div class="part-content">
					<div class="item-box wow slideInLeft">
						<img src="../../assets/img/tecSystem/icon8.png" alt="" />
						<h4 class="stitle">车辆自有终端监控</h4>
						<p class="text">
							主要针对自有车辆进行监控，外部车辆如能提供终端对接，可将车辆自有终端与平台进行数据对接后，实现对车辆的监控。
						</p>
					</div>
					<div class="item-box wow slideInLeft">
						<img src="../../assets/img/tecSystem/icon9.png" alt="" />
						<h4 class="stitle">便携式终端监控</h4>
						<p class="text">
							主要用在临时车辆或未在国家货运平台上监管的车辆，即提供自带电池的便携式终端，由司机携带或与货物绑定，通过回单时进行回收，实现对整个运输过程的监控。
						</p>
					</div>
					<div class="item-box wow slideInRight">
						<img src="../../assets/img/tecSystem/icon10.png" alt="" />
						<h4 class="stitle">移动端APP监控</h4>
						<p class="text">
							采用移动定位技术，使用手机端定位的方式完成对车辆及司机位置信息变动的监控。
						</p>
					</div>
					<div class="item-box wow slideInRight">
						<img src="../../assets/img/tecSystem/icon11.png" alt="" />
						<h4 class="stitle">国家货运平台监控</h4>
						<p class="text">
							国家货运平台对全国所有12吨以上货运车辆有强制监控要求，平台已完成与国家货运平台的数据对接准备，可以实现使用车牌号、VIN号对车辆位置信息监控。
						</p>
					</div>
				</div>
			</div>
			<div class="part-box wow slideInUp" id="certificate-part-box">
				<div class="container">
					<div class="part-titile">
						<h3 class="title">证照审核</h3>
					</div>
					<p class="intro-text">
						SO56运输管理系统目前的证照审核方面，包括对企业信息、司机信息以及车辆信息的审核工作
					</p>
					<div class="part-content">
						<div class="list-title">
							<b class="titleNum">1</b>
							<p class="name">人工审核，实现对平台提供的各类证照信息的审核工作</p>
						</div>
						<div class="list-title">
							<b class="titleNum">2</b>
							<p class="name">通过国家货运平台以及其他第三方数据平台的信息核验接口完成审核</p>
							<b class="arrow"></b>
							<span class="mustTitle">主要接口</span>

							<!--http://www.jq22.com/yanshi17658-->
							<div class="must-interface container" ref="mustInterface">
								<div class="must-box" ref="mItemBoxWrapper" :style="{width:bWidth+'px',left:MoveLong+'px'}">
									<div class="mitem-box" ref="mItemBox" v-for="item in mustItems" :style="{width:sWidth+'px'}">
										<img :src="item.img" alt="" />
										<p class="sname">{{item.name}}</p>
										<div class="mdetail">
											<h3 class="s-title">
												{{item.name}}
											</h3>
											<p class="stext">
												{{item.detail}}
											</p>
										</div>
									</div>
								</div>
							</div>
							<a href="javascript:;" class="prev" @click="prevClick"> <img src="../../assets/img/images/prev.png" alt="" /> </a>
							<a href="javascript:;" class="next" @click="nextClick"> <img src="../../assets/img/images/next.png" alt="" /> </a>
						</div>
						<!---->
					</div>
				</div>
			</div>

			<div class="part-box container wow slideInUp" id="interface-part-box">
				<div class="part-titile">
					<h3 class="title">接口对接及对内外服务</h3>
				</div>
				<div class="inter-part-content">
					<interBox v-for="(item,index) in interBoxDatas" :item='item' :key="index"></interBox>
				</div>
			</div>

			<div class="part-box wow slideInUp" id="data-part-box">
				<div class="container">
					<div class="part-titile">
						<h3 class="title">数据的导入</h3>
					</div>
					<div class="data-part-content">
						<div class="item-box" v-for="item in datasList">
							<div class="info-box">
								<img :src="item.img" alt="" />
								<p class="sname">{{item.name}}</p>
							</div>
							<div class="mdetail">
								<h3 class="s-title">
									{{item.name}}
								</h3>
								<p class="stext">
									{{item.detail}}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="part-box wow slideInUp" id="outData-part-box">
				<div class="container">
					<div class="part-titile">
						<h3 class="title">数据的导出</h3>
					</div>
					<div class="outData-part-content consignor-part-content wow slideInUp" data-wow-delay="0.5s">
						<p class="spart-title">发货人端</p>
						<div class="consignor-box">
							<div class="item-box">
								<div class="info-box">
									<img src="../../assets/img/images/icon30.png" alt="" />
									<p class="sname">自主派单</p>
								</div>
								<div class="mdetail">
									<h3 class="s-title">
										自主派单
									</h3>
									<p class="stext">
										填写取货单并下发，取货人上门取货，送往集配发货站
									</p>
								</div>
							</div>
							<div class="item-box">
								<div class="info-box">
									<img src="../../assets/img/images/icon31.png" alt="" />
									<p class="sname">上门取货</p>
								</div>
								<div class="mdetail">
									<h3 class="s-title">
										上门取货
									</h3>
									<p class="stext">
										填写取货单并下发，取货人上门取货，送往集配发货站
									</p>
								</div>
							</div>
							<div class="item-box">
								<div class="info-box">
									<img src="../../assets/img/images/icon32.png" alt="" />
									<p class="sname">我要用车</p>
								</div>
								<div class="mdetail">
									<h3 class="s-title">
										我要用车
									</h3>
									<p class="stext">
										客户自主选择合适车型车辆，平台调配相应车型车辆取货并送至目的地
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="outData-part-content shipper-part-content wow slideInUp" data-wow-delay="0.8s">
						<p class="spart-title">承运人端</p>
						<div class="consignor-box">
							<div class="item-box">
								<div class="info-box">
									<img src="../../assets/img/images/icon30.png" alt="" />
									<p class="sname">一键派单</p>
								</div>
								<div class="mdetail">
									<h3 class="s-title">
										一键派单
									</h3>
									<p class="stext">
										选择一个或多个订单，一键派发给配送员。
									</p>
								</div>
							</div>
							<div class="item-box">
								<div class="info-box">
									<img src="../../assets/img/images/icon32.png" alt="" />
									<p class="sname">指定车辆派单</p>
								</div>
								<div class="mdetail">
									<h3 class="s-title">
										指定车辆派单
									</h3>
									<p class="stext">
										设置车辆装载率，指定车辆，自定计算装车方案。
									</p>
								</div>
							</div>
							<div class="item-box">
								<div class="info-box">
									<img src="../../assets/img/images/icon34.png" alt="" />
									<p class="sname">地图派单</p>
								</div>
								<div class="mdetail">
									<h3 class="s-title">
										地图派单
									</h3>
									<p class="stext">
										地图上显示批量订单，根据位置，将订单手动分配给指定车辆。
									</p>
								</div>
							</div>
							<div class="item-box">
								<div class="info-box">
									<img src="../../assets/img/images/icon35.png" alt="" />
									<p class="sname">区域派单</p>
								</div>
								<div class="mdetail">
									<h3 class="s-title">
										区域派单
									</h3>
									<p class="stext">
										预设配送区域并绑定车辆，将区域内订单自动派发给绑定车辆。
									</p>
								</div>
							</div>
							<div class="item-box">
								<div class="info-box">
									<img src="../../assets/img/images/icon36.png" alt="" />
									<p class="sname">线路派单</p>
								</div>
								<div class="mdetail">
									<h3 class="s-title">
										线路派单
									</h3>
									<p class="stext">
										根据车型、配送点数量、车辆配送价格、订单数量等条件，自动将订单派发给符合条件的车辆。
									</p>
								</div>
							</div>
							<div class="item-box">
								<div class="info-box">
									<img src="../../assets/img/images/icon37.png" alt="" />
									<p class="sname">招标</p>
								</div>
								<div class="mdetail">
									<h3 class="s-title">
										招标
									</h3>
									<p class="stext">
										承运人将订单发给多个合作承运人和车队，根据合作承运人或车队上报的价格，将订单派发给一个合适的承运人或车队。
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="part-box">
				<div class="container wow slideInUp">
					<div class="part-titile">
						<h3 class="title">发展历程</h3>
					</div>
					<div id="myCarousel" class="carousel slide" data-ride="carousel" data-interval="5000">
					    <!-- 轮播（Carousel）指标 -->
					    <ol class="carousel-indicators">
					        <li v-for="(item,index) in progressList" data-target="#myCarousel" :data-slide-to="index" :class="(index == 0?'active':'')"></li>
					        <!--<li data-target="#myCarousel" data-slide-to="1"></li>
					        <li data-target="#myCarousel" data-slide-to="2"></li>-->
					    </ol>   
					    <!-- 轮播（Carousel）项目 -->
					    <div class="carousel-inner">
					        <div v-for="(item,index) in progressList" class="item" :class="(index == 0?'active':'')">
					            <div class="carousel-box">
					            	<ul class="small-box">
					            		<template v-for="(data, sindex) in item">
					            			<li v-if="sindex%2 == 0">
						            			<p class="time-box">{{data.time}}</p>
						            			<p class="text-font">
						            				{{data.detail}}
						            			</p>
						            		</li>
						            		<li v-else>
						            			<p class="text-font">
						            				{{data.detail}}
						            			</p>
						            			<p class="time-box">{{data.time}}</p>
						            		</li>
					            		</template>
					            		
					            		<!--<li>
					            			<p class="text-font">
					            				完成SO56司机接单功能、基础运力、标注运力、便易运品牌服务、运力监控功能和承运人模块的开发。
					            			</p>
					            			<p class="time-box">2017.03-2017.05</p>
					            		</li>
					            		<li>
					            			<p class="time-box">2017.06</p>
					            			<p class="text-font">
					            				SO56在北京地区开始投入运营，每月带来可观的效益。
					            			</p>
					            		</li>
					            		<li>
					            			<p class="text-font">
					            				SO56在成都地区投入运营，效益可观，反响很好。
					            			</p>
					            			<p class="time-box">2017.08</p>
					            		</li>
					            		<li>
					            			<p class="time-box">2018.04</p>
					            			<p class="text-font">
					            				SO56平台上线取货端和发货端功能。
					            			</p>
					            		</li>
					            		<li>
					            			<p class="text-font">
					            				SO56在长沙地区投入运营，并根据长沙需求生成导出单据行车日志，运单货品信息单功能。
					            			</p>
					            			<p class="time-box">2018.11</p>
					            		</li>-->
					            	</ul>
					            </div>
					        </div>
					        <!--<div class="item">
					            <div class="carousel-box">
					            	<ul class="small-box">
					            		<li>
					            			<p class="time-box">2016.11-2017.02</p>
					            			<p class="text-font">
					            				提出运力池概念,设计产品原型图,代号优送平台,后改名便易运,经过公司多次讨论最后命名为SO56。
					            			</p>
					            		</li>
					            		<li>
					            			<p class="text-font">
					            				提出运力池概念,设计产品原型图,代号优送平台,后改名便易运,经过公司多次讨论最后命名为SO56。
					            			</p>
					            			<p class="time-box">2016.11-2017.02</p>
					            		</li>
					            		<li>
					            			<p class="time-box">2016.11-2017.02</p>
					            			<p class="text-font">
					            				提出运力池概念,设计产品原型图,代号优送平台,后改名便易运,经过公司多次讨论最后命名为SO56。
					            			</p>
					            		</li>
					            		<li>
					            			<p class="text-font">
					            				提出运力池概念,设计产品原型图,代号优送平台,后改名便易运,经过公司多次讨论最后命名为SO56。
					            			</p>
					            			<p class="time-box">2016.11-2017.02</p>
					            		</li>
					            		<li>
					            			<p class="time-box">2016.11-2017.02</p>
					            			<p class="text-font">
					            				提出运力池概念,设计产品原型图,代号优送平台,后改名便易运,经过公司多次讨论最后命名为SO56。
					            			</p>
					            		</li>
					            		<li>
					            			<p class="text-font">
					            				提出运力池概念,设计产品原型图,代号优送平台,后改名便易运,经过公司多次讨论最后命名为SO56。
					            			</p>
					            			<p class="time-box">2016.11-2017.02</p>
					            		</li>
					            	</ul>
					            </div>
					        </div>
					        <div class="item">
					            <div class="carousel-box">
					            	<ul class="small-box">
					            		<li>
					            			<p class="time-box">2016.11-2017.02</p>
					            			<p class="text-font">
					            				提出运力池概念,设计产品原型图,代号优送平台,后改名便易运,经过公司多次讨论最后命名为SO56。
					            			</p>
					            		</li>
					            		<li>
					            			<p class="text-font">
					            				提出运力池概念,设计产品原型图,代号优送平台,后改名便易运,经过公司多次讨论最后命名为SO56。
					            			</p>
					            			<p class="time-box">2016.11-2017.02</p>
					            		</li>
					            		<li>
					            			<p class="time-box">2016.11-2017.02</p>
					            			<p class="text-font">
					            				提出运力池概念,设计产品原型图,代号优送平台,后改名便易运,经过公司多次讨论最后命名为SO56。
					            			</p>
					            		</li>
					            		<li>
					            			<p class="text-font">
					            				提出运力池概念,设计产品原型图,代号优送平台,后改名便易运,经过公司多次讨论最后命名为SO56。
					            			</p>
					            			<p class="time-box">2016.11-2017.02</p>
					            		</li>
					            		<li>
					            			<p class="time-box">2016.11-2017.02</p>
					            			<p class="text-font">
					            				提出运力池概念,设计产品原型图,代号优送平台,后改名便易运,经过公司多次讨论最后命名为SO56。
					            			</p>
					            		</li>
					            		<li>
					            			<p class="text-font">
					            				提出运力池概念,设计产品原型图,代号优送平台,后改名便易运,经过公司多次讨论最后命名为SO56。
					            			</p>
					            			<p class="time-box">2016.11-2017.02</p>
					            		</li>
					            	</ul>
					            </div>
					        </div>
					    -->
					    </div>
					    <!-- 轮播（Carousel）导航 -->
					    <a class="left carousel-control" href="#myCarousel" role="button" data-slide="prev">
					        <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
					        <span class="sr-only">Previous</span>
					    </a>
					    <a class="right carousel-control" href="#myCarousel" role="button" data-slide="next">
					        <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
					        <span class="sr-only">Next</span>
					    </a>
					</div>
				</div>
			</div>
		</div>
    <!-- <Suggest></Suggest> -->
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '../../components/common/header.vue'
	import Footer from '../../components/common/footer.vue'
	import { WOW } from '../../assets/js/wow.min.js'
  // import Suggest from '../../components/common/suggest.vue'
	export default {
		components: {
			Header,
			Footer,
      // Suggest,
			interBox: {
				template: `<div class="item-box">\n
						<img :src="item.src" alt="" class="list-img" style="flex: 0 0 66px;height: 66px;margin-right: 20px;"/>\n
							<div class="right" style="flex: 1;text-align: left;">\n
								<p class="s-title" style="font-size: 18px;color: #061F3E;margin-bottom: 16px;">{{item.title}}\n
								</p>\n
								<p class="text" style="font-size: 12px;line-height: 18px;color: #979EA7;">{{item.text}}\n
								</p>\n
							</div>\n
						</div>`,
				props: ['item']
			}
		},
		data() {
			return {
				classifyList: [{
						"id": 10001,
						"name": "LBS",
						"text": "手机定位服务",
						"isShown": false,
						"detail": "通俗的讲就是手机定位服务。它是通过电信移动运营商的无线电通讯网络（如GSM网、CDMA网）或外部定位方式(如GPS、北斗)获取移动终端用户的位置信息（地理坐标，或大地坐标），在地理信息系统平台的支持下，为用户提供相应服务。"
					},
					{
						"id": 10002,
						"name": "车联网",
						"isShown": false,
						"text": "互联互通、信息共享",
						"detail": "车联网是由车辆位置、速度和路线等信息构成的巨大交互网络。通过GPS、RFID、传感器、摄像头图像处理等装置，车辆可以完成自身环境和状态信息的采集。"
					},
					{
						"id": 10003,
						"name": "OTMS",
						"isShown": false,
						"text": "开放式的运输管理系统",
						"detail": "开放式的运输管理系统，作为SaaS软件的一种，主要功能包括：业务流程管理（BPM）、托运单管理、订单跟踪、货物跟踪、从业人员管理、运输业户管理，实现运输业务流程的可视化监控、结算管理等。"
					},
					{
						"id": 10004,
						"name": "AI",
						"isShown": false,
						"text": "AI智能管理",
						"detail": "人工智能，它是研究、开发用于模拟、延伸和扩展人的智能的理论、方法、技术及应用系统的一门新的技术科学。"
					},
					{
						"id": 10005,
						"name": "SaaS",
						"isShown": false,
						"text": "软件即服务",
						"detail": "它是一种通过互联网提供软件的模式。这种模式下，客户不需要购买软件产品，只需要为他所获得的服务支付费用，并通过互联网获得厂商所提供的服务。"
					},
					{
						"id": 10006,
						"name": "云服务",
						"isShown": false,
						"text": "云服务平台",
						"detail": "它是基于互联网的相关服务的增加、使用和交互模式，通常涉及通过互联网来提供动态易扩展且经常是虚拟化的资源。"
					},
					{
						"id": 10007,
						"name": "多平台",
						"isShown": false,
						"text": "多平台错位管理",
						"detail": "双平台错位管理，移动APP+PC终端结合，实现智能物流与共享物流的共生发展。"
					}
				],
				mustItems: [{
						"img": require("../../assets/img/images/icon12.png"),
						"name": "车主真实性验证",
						"detail": "通过指定车牌号、车主姓名及车主电话，验证车主真实性。"
					},
					{
						"img": require("../../assets/img/images/icon13.png"),
						"name": "套牌车验证",
						"detail": "提供按车牌号、行政区划代码（县级）判断车辆当前定位数据是否匹配服务。通过一个车的所报位置与平台验证的实际位置做比对，从而判断出是否为套牌车。"
					},
					{
						"img": require("../../assets/img/images/icon14.png"),
						"name": "道路运输证验证",
						"detail": "通过指定车牌号、道路运输证号码，验证道路运输证信息是否准确。"
					},
					{
						"img": require("../../assets/img/images/icon15.png"),
						"name": "车辆行驶证信息查询",
						"detail": "对提供指定车牌号车牌颜色的车辆行驶证信息查询。"
					},
					{
						"img": require("../../assets/img/images/icon16.png"),
						"name": "道路运输证查询",
						"detail": "通过指定车牌号、车牌颜色查询道路运输证号码及有效期等信息。"
					},
					{
						"img": require("../../assets/img/images/icon17.png"),
						"name": "车辆里程查询",
						"detail": "基于国家货运平台智能transmap-mileage 算法，本接口提供指定车牌号、指定 时间段查询车辆实际行驶里程信息，开始时间和结束时间不能超过 24 小时。"
					},
					{
						"img": require("../../assets/img/images/icon40.png"),
						"name": "车辆运营数据查询",
						"detail": "根据车牌号按月查询车辆行驶总里程、运营时长及运营率等信息，帮助企业随时掌握车辆运营数据。"
					}
				],
				interBoxDatas: [{
					"title": "资金流水单",
					"src": require("../../assets/img/images/icon10.png"),
					"text": "SO56运输管理系统目前的资金流水单是根据国家无车承运人平台要求的资金流水条目进行手动添加生成的，可根据用户需要实现通过银行接口的方式生成资金流水单。"
				}, {
					"title": "数据对接",
					"src": require("../../assets/img/images/icon11.png"),
					"text": "与国家无车承运人平台的对接工作已准备完成，可在需要时短期内实现数据对接。"
				}, {
					"title": "异常车辆处理",
					"src": require("../../assets/img/images/icon22.png"),
					"text": "配送车辆在运输途中出现异常，配送员可将异常上报到服务站，附近的服务站快速响应解决问题，保证货物准时送达目的地。"
				}, {
					"title": "评价服务",
					"src": require("../../assets/img/images/icon23.png"),
					"text": "配送员配送完成后，发货人可对配送员的服务进行评价，保证配送的服务质量。"
				}],
				datasList: [
					{
						"img": require("../../assets/img/images/icon24.png"),
						"name": "微信导入",
						"detail": "发货人通过关注SO56的微信公众号，在微信公众号中直接将订单下发到SO56平台上。"
					},
					{
						"img": require("../../assets/img/images/icon25.png"),
						"name": "直接填写",
						"detail": "企业在平台中的订单管理页面中直接填写订单信息新增订单。"
					},
					{
						"img": require("../../assets/img/images/icon26.png"),
						"name": "批量导入",
						"detail": "通过Excel表格将大批量的订单一键导入到平台上。"
					},
					{
						"img": require("../../assets/img/images/icon27.png"),
						"name": "按模板导入",
						"detail": "下载平台模板，将大批量订单按模板导入到平台上。"
					},
					{
						"img": require("../../assets/img/images/icon28.png"),
						"name": "接口导入",
						"detail": "通过接口将订单导入到SO56平台。"
					}
				],
				progressList: [
					[{
						"time": "2016.11-2017.02",
						"detail": "提出运力池概念,设计产品原型图,代号优送平台,后改名便易运,经过公司多次讨论最后命名为SO56。"
					},
					{
						"time": "2017.03-2017.05",
						"detail": "完成SO56司机接单功能、基础运力、标注运力、便易运品牌服务、运力监控功能和承运人模块的开发。"
					},
					{
						"time": "2017.06",
						"detail": "SO56在北京地区开始投入运营，每月带来可观的效益。"
					},
					{
						"time": "2017.08",
						"detail": "SO56在成都地区投入运营，效益可观，反响很好。"
					},
					{
						"time": "2018.04",
						"detail": "SO56平台上线取货端和发货端功能。"
					},
					{
						"time": "2018.11",
						"detail": "SO56在长沙地区投入运营，并根据长沙需求生成导出单据行车日志，运单货品信息单功能。"
					}],
					[{
						"time": "2019.03",
						"detail": "SO56平台添加对账单功能"
					},
					{
						"time": "2019.05",
						"detail": "SO56平台针对西凤酒实际情况添加预发货单功能"
					}]
				],
				sWidth: 0,
				bWidth: 0,
				removeNum: 0,
				MoveLong: 0
			}
		},
		created: function(){
			new WOW({live: false}).init();
		},
		methods: {
			prevClick: function() {
				if(this.removeNum < this.mustItems.length - 5) {
					console.log("prev click") //可左移动
					this.MoveLong -= this.sWidth + 3;
					this.removeNum++;
				}
			},
			nextClick: function() {
				if(this.removeNum > 0 && this.removeNum < 5) {
					console.log("next click");
					this.MoveLong += this.sWidth - 3;
					this.removeNum--;
				}
			}
		},
		computed: {
			setWidth: function() {
				var mWidth = this.$refs.mustInterface.offsetWidth;
				console.log(this.$refs.mItemBox.length)
				for(var i = 0; i < this.$refs.mItemBox.length; i++) {
					this.$refs.mItemBox.offsetWidth = mWidth * 0.2;
				}
				this.sWidth = mWidth * 0.2 - 2;
				this.bWidth = this.sWidth * (this.mustItems.length);
				
			}
		},
		mounted: function() {
			var that = this;
			this.$nextTick(() => {
				that.setWidth;
			})
			new WOW({live: false}).init();
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/animate.min.css");
	@import '../../assets/css/technology.css'
</style>


// WEBPACK FOOTER //
// src/components/pages/technology_system.vue